import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export var getBalanceParamsFrom = function getBalanceParamsFrom(id) {
  var _id$split = id.split('-'),
    _id$split2 = _slicedToArray(_id$split, 2),
    _id$split2$ = _id$split2[0],
    balanceType = _id$split2$ === void 0 ? '' : _id$split2$,
    _id$split2$2 = _id$split2[1],
    balanceCode = _id$split2$2 === void 0 ? '' : _id$split2$2;
  return {
    balanceType: balanceType,
    balanceCode: balanceCode
  };
};
var TOP_SHIFT = 26;
export var calculateStylesForDesktop = function calculateStylesForDesktop(_ref) {
  var balancesWrapper = _ref.balancesWrapper,
    parentRect = _ref.parentRect;
  if (!parentRect || !balancesWrapper) {
    return undefined;
  }
  return {
    top: parentRect.top + window.scrollY + TOP_SHIFT,
    left: parentRect.left + window.scrollX - balancesWrapper.clientWidth / 2
  };
};